import { RegistrationRecieptCommand } from '../../../registration_receipt/commands/registration_reciept_command';
import { RemoveFromRegisterSectionsCommand } from '../../course_scheduler/commands/remove_from_register_sections_command';
import { RemoveSectionsRegistrationAttributesCommand } from '../../../registration_attributes/commands/remove_section_registration_attributes_command';
import { IPreventTransientAccessQueryResult } from '../../../prevent_transient_access/queries/prevent_transient_access_query';
import { RegAttributesForSections } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionsQuery } from '../../course_scheduler/queries/scheduled_sections_query';
import { RegistrationAlertsServant } from '../../course_scheduler/servants/registration_alerts_servant';
import { SchedulerModel } from '../../course_scheduler/models/scheduler_model';
import { ITermCoursesDatasource } from '../../term_courses/datasources/term_courses_datasource';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { RegistrationAlertMessages } from '../../course_scheduler/types/registration_alert_messages';
import { WaitlistCallbackServant } from '../../course_scheduler/servants/waitlist_callback_servant';
import { RegistrationCallbackServant } from '../../course_scheduler/servants/registration_callback_servant';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ScheduledSectionStatus } from '../../course_scheduler/types/scheduled_section_status_enum';
import * as _4 from 'lodash4';
import { OUTCOME_STATUS_TYPES } from '../../course_scheduler/strategies/registration_waitlist_outcome_status_strategy';
import { Section } from '../../sections/builders/section_builder';
import { RegistrationReceiptServant } from '../../course_scheduler/servants/registration_receipt_servant';
import { INotificationDelegate } from '../../../global/helpers/scheduler_notification_delegate';
import { MultiSectionsWaitlistRequestStateCommand } from '../../../request_state/commands/multi_sections_waitlist_request_state_command';

export type WaitlistSectionCommand = (
  sectionIds: number[],
  section_pins?: Record<string, any>,
  regAttributesForSections?: RegAttributesForSections,
  student_credentials?: IPreventTransientAccessQueryResult['output']
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'waitlistSectionCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngSectionsDatasource: ISectionsDatasource,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      ngRegistrationAlertsServant: RegistrationAlertsServant,
      ngWaitlistCallbackServant: WaitlistCallbackServant,
      ngRegistrationCallbackServant: RegistrationCallbackServant,
      pusherService: any,
      ngSchedulerModel: SchedulerModel,
      $stateParams: ng.ui.IStateParamsService,
      $timeout: any,
      appConfigModel: any,
      $q: any,
      log: any,
      getTermCoursesandScheduledSectionsCommand: ICommand,
      ngScheduledSectionsQuery: ScheduledSectionsQuery,
      registrationActivityCommand: ICommand,
      registrationRecieptCommand: RegistrationRecieptCommand,
      ngRegistrationReceiptServant: RegistrationReceiptServant,
      removeFromRegisterSectionsCommand: RemoveFromRegisterSectionsCommand,
      removeSectionsRegistrationAttributesCommand: RemoveSectionsRegistrationAttributesCommand,
      ngSchedulerNotificationDelegate: INotificationDelegate,
      multiSectionsWaitlistRequestStateCommand: MultiSectionsWaitlistRequestStateCommand
    ): ICommand => {
      return defineCommandORM(
        'waitlistSectionCommand',
        (
          deferred,
          sectionIds: number[],
          section_pins = {},
          regAttributesForSections: RegAttributesForSections = {},
          student_credentials?: IPreventTransientAccessQueryResult['output']
        ) => {
          const SECONDS_60 = 60000;
          const timeout = $q.defer();

          const schedulerModel = ngSchedulerModel.read();
          const sectionsToWaitlist = sectionIds.map(
            (sectionId) =>
              _4.find(
                [...ngScheduledSectionsQuery.result.list, ..._4.toArray(ngSectionsDatasource.read())],
                (section) => section.id === sectionId
              ) as Section
          );
          const showWaitlistMessage = appConfigModel.model.member_features['reg-auto_waitlist_message'];

          if (showWaitlistMessage) {
            ngRegistrationAlertsServant.showPendingAlert(
              RegistrationAlertMessages.PENDING_AUTO_WAITLIST_WAITLISTED_TEXT
            );
          } else {
            ngRegistrationAlertsServant.showPendingAlert();
          }

          $timeout(() => {
            timeout.resolve();
          }, SECONDS_60);

          // Waitlist Callback
          const waitlistAddCallback = (data: any) => {
            $q.all([
              registrationActivityCommand($stateParams.termId),
              removeFromRegisterSectionsCommand(sectionIds),
              removeSectionsRegistrationAttributesCommand(sectionIds)
            ]).then(() => {
              const sectionsReceiptData = ngRegistrationReceiptServant.getReceiptData(
                sectionsToWaitlist.map((section) => section.id)
              );
              registrationRecieptCommand(sectionsReceiptData, true).then(() => {
                ngRegistrationAlertsServant.hidePendingAlert();

                sectionIds.forEach((sectionId) => {
                  const result = data[sectionId];
                  const waitlistPusherOutcome: any = {
                    id: result.id,
                    message: _4.get(result, 'message'),
                    request_type: 'WAITLIST',
                    success: result.success,
                    place_in_waitlist: _4.get(result, 'place_in_waitlist', 0),
                    is_registered: _4.get(result, 'is_registered', false),
                    is_waitlisted: _4.get(result, 'is_waitlisted', false)
                  };

                  const isWaitlistRequestWaitlisted = ngWaitlistCallbackServant.isWaitlistRequestResultByType(
                    waitlistPusherOutcome,
                    OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_WAITLISTED
                  );
                  const isWaitlistRequestRegistered = ngWaitlistCallbackServant.isWaitlistRequestResultByType(
                    waitlistPusherOutcome,
                    OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_REGISTERED
                  );
                  const isWaitlistRequestFailed = ngWaitlistCallbackServant.isWaitlistRequestResultByType(
                    waitlistPusherOutcome,
                    OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_FAILED
                  );

                  if (isWaitlistRequestWaitlisted) {
                    getTermCoursesandScheduledSectionsCommand($stateParams.termId).then(() =>
                      ngWaitlistCallbackServant.waitlistSuccess(waitlistPusherOutcome)
                    );
                  } else if (isWaitlistRequestRegistered) {
                    getTermCoursesandScheduledSectionsCommand($stateParams.termId).then(() => {
                      ngRegistrationCallbackServant.setRegisteredStatus(waitlistPusherOutcome);
                      ngRegistrationCallbackServant.showAutoRegisteredAlert(waitlistPusherOutcome);
                    });
                  } else if (isWaitlistRequestFailed) {
                    ngWaitlistCallbackServant.waitlistFails(waitlistPusherOutcome);
                  }
                });

                // Only resolve after callback;
                multiSectionsWaitlistRequestStateCommand(false);
                deferred.resolve(QueryMediator.runQueries(ngSectionsDatasource, ngTermCoursesDatasource));
              });
            });
          };

          // Setup callback to listen for waitlist pusher response
          pusherService.bindToPusherEvent(
            schedulerModel.channel_name,
            'registration_outcome_waitlist_add',
            waitlistAddCallback
          );

          sectionsToWaitlist.forEach((sectionToWaitlist) => {
            if (sectionToWaitlist) {
              sectionToWaitlist.status = ScheduledSectionStatus.PENDING;
              ngSectionsDatasource.put(sectionToWaitlist);
            }
          });
          QueryMediator.runQueries(ngSectionsDatasource, ngTermCoursesDatasource);

          // Call server to initiate a waitlist for these sections
          $http({
            method: 'POST',
            url: `/reg/register/term/${$stateParams.termId}/`,
            data: {
              method: 'W',
              sections: sectionIds,
              section_pins,
              ...regAttributesForSections,
              ...student_credentials
            },
            cache: false,
            timeout: timeout.promise
          }).catch(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            sectionsToWaitlist.forEach((sectionToWaitlist) => {
              if (sectionToWaitlist) {
                sectionToWaitlist.status = ScheduledSectionStatus.UNSCHEDULED;
                ngSectionsDatasource.put(sectionToWaitlist);
              }
            });
            QueryMediator.runQueries(ngSectionsDatasource, ngTermCoursesDatasource);
            log.issue('failed to add to waitlist, please try again');
            if (_4.has(data, 'detail')) {
              ngSchedulerNotificationDelegate.warn(data.detail);
            }
            multiSectionsWaitlistRequestStateCommand(false);
            deferred.reject(data);
          });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/waitlist_section_command.ts